// extracted by mini-css-extract-plugin
export default {"Playback":"VideoPlayerControls-module__Playback--iVnbt","FullScreen":"VideoPlayerControls-module__FullScreen--DVnqE","AudioMute":"VideoPlayerControls-module__AudioMute--jPrWH"};